import { Link } from 'react-router-dom';
import './404.css'

function Page404() {
    return (
        <div className="notfound-main">
            <div className="text-center">
                <p className='error404'>404</p>
                <h1 className='txt'>Page not found</h1>
                <p className='desc'>Sorry, we couldn’t find the page you’re looking for.</p>
                <div className='button-page'>
                    <Link to="/"><button className='go-back-home'>Go back home</button></Link>
                </div>
            </div>
        </div>
    );
}

export default Page404